/**
 * @generated SignedSource<<60229a0828a76cc4e3cf9301494abb5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TranscriptModalRegenerateSummaryMutation$variables = {
  meetingRecordingId: string;
};
export type TranscriptModalRegenerateSummaryMutation$data = {
  readonly regenerateSummary: {
    readonly ok: boolean;
  } | null;
};
export type TranscriptModalRegenerateSummaryMutation = {
  response: TranscriptModalRegenerateSummaryMutation$data;
  variables: TranscriptModalRegenerateSummaryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meetingRecordingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "meetingRecordingId",
        "variableName": "meetingRecordingId"
      }
    ],
    "concreteType": "RegenerateSummary",
    "kind": "LinkedField",
    "name": "regenerateSummary",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TranscriptModalRegenerateSummaryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TranscriptModalRegenerateSummaryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7f64795a120e4bc3e485bafabfa75dc0",
    "id": null,
    "metadata": {},
    "name": "TranscriptModalRegenerateSummaryMutation",
    "operationKind": "mutation",
    "text": "mutation TranscriptModalRegenerateSummaryMutation(\n  $meetingRecordingId: ID!\n) {\n  regenerateSummary(meetingRecordingId: $meetingRecordingId) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "86f1e87ee5207de76369bded4f96138b";

export default node;
